var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-download-grp" }, [
    _c(
      "div",
      { staticClass: "file-download-area" },
      [
        _vm._l(_vm.theFileList, function(theFile, theIndex) {
          return [
            _c("swb-file-download", {
              ref: "fileDownloads",
              refInFor: true,
              class: { last: theIndex == _vm.theFileList.length - 1 },
              attrs: {
                clickable: !_vm.autoDownload && !_vm.theFileStates[theIndex],
                fileNameHeader: _vm.fileNameHeader,
                seqNo: theIndex + 1,
                url: theFile.url,
                post: theFile.post,
                asForm: theFile.asForm,
                params: theFile.params,
                data: theFile.data,
                fileName: theFile.fileName,
                onStarted: _vm._onFileStarted,
                onResult: _vm._onFileResult
              }
            })
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.summary
      ? _c(
          "div",
          { staticClass: "summary" },
          [
            _vm._v("\n        下载文件 总数："),
            _c("label", { staticClass: "total" }, [_vm._v(_vm._s(_vm.total))]),
            _vm._v(" , 成功："),
            _c("label", { staticClass: "done" }, [_vm._v(_vm._s(_vm.done))]),
            _vm._v(" ，失败："),
            _c("label", { staticClass: "fail" }, [_vm._v(_vm._s(_vm.fail))]),
            _vm._v(" "),
            _vm.xlsExport == true
              ? _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "20px", color: "navy" },
                    model: {
                      value: _vm.valueAsNormalFormats,
                      callback: function($$v) {
                        _vm.valueAsNormalFormats = $$v
                      },
                      expression: "valueAsNormalFormats"
                    }
                  },
                  [_vm._v("按常规格式输出数据")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("extBtn")
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15aa309c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15aa309c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/FileDownloadGrp.vue
// module id = 2167
// module chunks = 0